import { forwardRef, useMemo } from 'react';

import { getCountryFlag } from '../flags/flags.helper';
import { usePhoneFieldContext } from '../phone-field.context';

import * as S from './country-selector.styles';

type TriggerElementProps = {
  className?: string;
};

function Flag() {
  const { state, flagMode } = usePhoneFieldContext();
  const Flag = useMemo(
    () => getCountryFlag(flagMode, state.selectedCountry),
    [flagMode, state.selectedCountry],
  );

  if (!Flag) return null;
  return <Flag />;
}

export const TriggerElement = forwardRef<HTMLDivElement, TriggerElementProps>(
  (props, ref) => {
    return (
      <S.TriggerElementWrapper ref={ref} {...props} aria-label="Select country code">
        <Flag />
        <S.Arrow className="arrow" />
      </S.TriggerElementWrapper>
    );
  },
);
